import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEReactSelect, FormEditButton, FHETextField, FHEDivider } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import memoizeOne from 'memoize-one';
import { updateProductModule } from '../../../../../../data/Products/actions';

class BinaryPowerSwitch extends PureComponent {
    static propTypes = {
        enumProductModulesTypes: PropTypes.array.isRequired,
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        planningMode: PropTypes.string,
        moduleType: PropTypes.string,
        brand: PropTypes.string,
        model: PropTypes.string,
        code: PropTypes.string,
        planningSynched: PropTypes.number,
        energyClass: PropTypes.string,
        value: PropTypes.string,
        label: PropTypes.string,
        planningType: PropTypes.string,
        favorite: PropTypes.number,
        year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        updateProductModule: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        type: PropTypes.string,
        lineType: PropTypes.string
    };

    static defaultProps = {
        planningMode: null,
        moduleType: null,
        brand: null,
        model: null,
        code: null,
        planningSynched: null,
        energyClass: null,
        value: null,
        label: null,
        planningType: null,
        favorite: null,
        year: null,
        type: null,
        lineType: null
    };

    constructor(props) {
        super(props);
        const { history } = props;
        this.state = {
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: {
                moduleType: null,
                brand: null,
                energyClass: null,
                label: null,
                year: null
            }
        };

        this.energyClasses = [
            { value: 'A+++', label: Translator.translate(`general.productModules.A+++`) },
            { value: 'A++', label: Translator.translate(`general.productModules.A++`) },
            { value: 'A+', label: Translator.translate(`general.productModules.A+`) },
            { value: 'A', label: Translator.translate(`general.productModules.A`) },
            { value: 'B', label: Translator.translate(`general.productModules.B`) },
            { value: 'C', label: Translator.translate(`general.productModules.C`) },
            { value: 'D', label: Translator.translate(`general.productModules.D`) }
        ];
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled } = state;
        const { moduleType, brand, energyClass, label, year } = props;
        if (formDisabled) {
            let form = {
                moduleType: state.form.moduleType,
                brand: state.form.brand,
                energyClass: state.form.energyClass,
                label: state.form.label,
                year: state.form.year
            };
            if (props.moduleType !== state.form.moduleType) {
                form.moduleType = moduleType;
            }
            if (props.brand !== state.form.brand) {
                form.brand = brand;
            }
            if (props.energyClass !== state.form.energyClass) {
                form.energyClass = energyClass;
            }
            if (props.label !== state.form.label) {
                form.label = label;
            }
            if (props.year !== state.form.year) {
                form.year = year;
            }
            return {
                form: form
            };
        } else {
            return null;
        }
    }

    handleEdit = () => {
        const { formDisabled } = this.state;
        this.setState({
            formDisabled: !formDisabled
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    handleChangeWithVerification = event => {
        const { form, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            brand: 100,
            label: 255,
            year: 11
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = form[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            form: { ...form, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    handleChange = event => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [event.target.name]: event.target.value }
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { moduleType, brand, energyClass, label, year } = this.props;
        this.setState({
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: {
                moduleType: moduleType,
                brand: brand,
                energyClass: energyClass,
                label: label,
                year: year
            }
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(newForm).forEach(key => {
            if (newForm[key] === '') {
                newForm[key] = null;
            }
        });
        this.setState({
            form: newForm
        });
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductModule, match, code, type, lineType, history } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });

            return updateProductModule(match.params.homeId, match.params.productIdentifier, match.params.productType, code, form, lineType, type)
                .then(() => {
                    Toastr.success(Translator.translate(`genericproducts.actions.editProductModuleSuccess`));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(Translator.translate(`genericproducts.actions.editProductModuleError`));
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate(`genericproducts.actions.editProductModuleError`));
                    }
                });
        }
    };

    validateForm = () => {
        const errors = {};

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    getSelectedEnergyClass = memoizeOne(energyClass => {
        return this.energyClasses.find(x => x.value === energyClass);
    });

    getSelectedType = memoizeOne(type => {
        const { enumProductModulesTypes } = this.props;
        return enumProductModulesTypes.find(x => x.value === type);
    });

    handleReactSelect = (event, options) => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [options.name]: event.value }
        });
    };

    render() {
        const { formDisabled, textInput_error, sendLoading, form } = this.state;
        const { enumProductModulesTypes, planningMode, model, code, planningSynched, value, planningType, favorite, theme, profile, type, lineType, history } = this.props;
        const userRightUpdate =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`productModules_${lineType}_${type}_update`);
        return (
            <Fragment>
                {userRightUpdate && (
                    <FormEditButton
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                )}
                <FHEDivider color={theme.palette.colors.grey100} />
                <FHEContainerForm>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="label"
                                value={!form.label || form.label === null ? '' : form.label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeWithVerification}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="moduleType"
                                label={Translator.translate('general.table.column.moduleType')}
                                disabled={formDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedType(form.moduleType)}
                                choices={enumProductModulesTypes}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="energyClass"
                                label={Translator.translate('general.table.column.energyClass')}
                                disabled={formDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedEnergyClass(form.energyClass)}
                                choices={this.energyClasses}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="brand"
                                value={!form.brand || form.brand === null ? '' : form.brand}
                                error={textInput_error.brand}
                                label={Translator.translate('general.table.column.brand')}
                                name="brand"
                                onChange={this.handleChangeWithVerification}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="year"
                                value={!form.year || form.year === null ? '' : form.year}
                                error={textInput_error.year}
                                label={Translator.translate('general.table.column.year')}
                                name="year"
                                onChange={this.handleChangeWithVerification}
                            />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
                <FHEDivider color={theme.palette.colors.grey100} />
                <FHEContainerForm>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningMode')}
                                itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningSynched')}
                                itemContent={Translator.translate(`general.productModules.${planningSynched}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningType')}
                                itemContent={Translator.translate(`general.productModules.${planningType}`)}
                            />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
                <FHEDivider color={theme.palette.colors.grey100} />
                <FHEContainerForm>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.value')} itemContent={value} />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.favorite')}
                                itemContent={Translator.translate(`general.productModules.${favorite}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.model')} itemContent={model} />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    let productModule;
    if (state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'])) {
        productModule = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map()).first();
    }
    if (productModule === undefined) {
        productModule = new Map();
    }
    const enums = state.environments[history.environment].enums;
    return {
        enumProductModulesTypes: enums.productModulesTypes || [],
        profile: state.data.user,
        type: product.get('type'),
        lineType: productModule.get('productType'),
        planningMode: productModule.get('planningMode'),
        moduleType: productModule.get('moduleType'),
        brand: productModule.get('brand'),
        model: productModule.get('model'),
        code: productModule.get('code'),
        planningSynched: productModule.get('planningSynched'),
        energyClass: productModule.get('energyClass'),
        value: productModule.get('value'),
        label: productModule.get('label'),
        planningType: productModule.get('planningType'),
        favorite: productModule.get('favorite'),
        year: productModule.get('year')
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Zwave/BinaryPowerSwitch/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductModule
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(BinaryPowerSwitch))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Zwave/BinaryPowerSwitch/index.js